import { createSlice } from '@reduxjs/toolkit';
import { fetchSongs, updateSong } from "./thunk";

const SongList = createSlice({
  name: 'SongLibraryList',
  initialState: {
    items: [],
    loading: false,
    error: null,
    success: null,
  },
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    clearSuccess: (state) => {
      state.success = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSongs.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSongs.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload;
      })
      .addCase(fetchSongs.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(updateSong.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateSong.fulfilled, (state, action) => {
        state.loading = false;
        state.success = 'Song updated successfully';
        // Update the song in the items array
        const index = state.items.findIndex(song => song.id === action.payload.id);
        if (index !== -1) {
          state.items[index] = action.payload;
        }
      })
      .addCase(updateSong.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearError, clearSuccess } = SongList.actions;

// Selectors
export const selectAllSongs = (state) => state.SongLibraryList.items;
export const selectSongsLoading = (state) => state.SongLibraryList.loading;
export const selectSongsError = (state) => state.SongLibraryList.error;

export default SongList.reducer;
